module.exports = __webpack_public_path__ + "img/TZS09677.c0061c8c.jpeg";